<template>
  <auth-layout :heading="$t(isNewUser ? 'welcome' : 'resetPassword')">

    <v-form v-model="isFromValid">

      <email-input
        v-model="resetObj.email"
        :error-messages="errorMessages.email"/>

      <password-pair
        v-if="isWaitingForReset"
        :password="resetObj.password"
        :password_confirmation="resetObj.password_confirmation"
        :error-messages="errorMessages.password"
        @changed="val => resetObj.password = val"
        @changedConfirm="val => resetObj.password_confirmation = val"
        @submit="submit"
      />

      <v-progress-linear
        v-else
        :indeterminate="true"
      />
    </v-form>

    <v-btn
      slot="navigation"
      :to="{name: 'login'}"
      flat
    >
      {{ $t('back') }}
    </v-btn>
    <v-btn
      slot="action"
      :loading="isLoading"
      :disabled="!isFromValid || isLoading"
      color="primary"
      @click="submit">{{ $t(isNewUser ? 'createAccount' : 'resetPassword') }}
    </v-btn>

  </auth-layout>
</template>

<script>
import UserApi from '@/api/UserApi'
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import PasswordPair from '@/components/global-components/inputs/PasswordPair.vue'
import AuthLayout from '@/components/layouts/AuthLayout'
import { mapActions } from 'vuex'

export default {
  name: 'PasswordReset',
  components: { AuthLayout, EmailInput, PasswordPair },
  props: [],
  data () {
    return {
      isFromValid: false,
      isLoading: false,
      isWaitingForReset: true,
      resetObj: {
        email: '',
        password: '',
        password_confirmation: ''
      },
      errorMessages: {}
    }
  },
  computed: {
    isNewUser () {
      return this.$route.query.hasOwnProperty('userify')
    }
  },
  methods: {
    ...mapActions('user', ['setUser']),
    async submit () {
      if (!this.isFromValid) return

      this.isLoading = true
      try {
        this.isWaitingForReset = false
        const token = this.$route.query[this.isNewUser ? 'userify' : 'token']

        const authObj = await UserApi.resetPassword({
          ...this.resetObj,
          token
        })

        UserApi.makeAuth(authObj)

        this.setUser(authObj.user)
        this.$router.push({ name: 'login' })
        this.$notification({
          success: {
            message: [this.$t('passwordChangedAndYouLoggedIn')]
          }
        })
      } catch (e) {
        this.isWaitingForReset = true
        this.errorMessages = e.errors
      }
      this.isLoading = false
    }
  },
  watch: {
    resetObj: {
      deep: true,
      handler () { this.errorMessages = {} }
    }
  },
  i18n: {
    messages: {
      de: {
        welcome: 'Willkommen bei Elsazeit',
        resetPassword: 'Kennwort zurücksetzen',
        back: 'Zurück',
        createAccount: 'Konto erstellen',
        passwordChangedAndYouLoggedIn: 'Kennwort wurde erfolgreich gesetzt'
      },
      en: {
        welcome: 'Welcome',
        resetPassword: 'Reset password',
        back: 'back',
        createAccount: 'Create account',
        passwordChangedAndYouLoggedIn: 'Password has been changed'
      },
      tr: {
        welcome: 'Hoş geldiniz',
        resetPassword: 'Şifreyi sıfırlayın',
        back: 'geri',
        createAccount: 'Hesap oluşturun',
        passwordChangedAndYouLoggedIn: 'Şifre değiştirildi'
      },
      ru: {
        welcome: 'Добро пожаловать',
        resetPassword: 'Изменить пароль',
        back: 'Назад',
        createAccount: 'Создать пользователя',
        passwordChangedAndYouLoggedIn: 'Пароль успешно изменен'
      }
    }
  }
}
</script>
